// Based off of:
// https://github.com/stolksdorf/egads/blob/master/egads.js

function create( obj, parent, props ) {
  obj.prototype = Object.assign(
    Object.create( parent.prototype, {
      constructor : { value : obj }
    } ),
    props
  )
  return obj
}

function toString( ) {
  const b = []
  b.push( this.name )
  // if ( b.message && b.message != '' ){
  b.push( ': ' )
  b.push( this.message )
  // }
  b.push( ' ' )
  b.push( JSON.stringify( this ) )
  return b.join( '' )
}

function toObject( ) {
  return { message : this.message, ...this }
}

function getParams( possibleObj, message, status, name, fields ) {
  if ( possibleObj && typeof possibleObj === 'object' ) {
    return possibleObj; // its a single obj
  }
  const o = { ...fields }
  if ( message !== undefined ) { o.message = message }
  if ( status !== undefined ) { o.status = status }
  if ( name !== undefined ) { o.name = name }
  return o
}

function extend( name = 'Error', status, msg, fields ) {

  const parent = this
  const params = getParams( name, msg, status, name, fields )

  // 
  const defaultParams = { ...parent.defaultParams, ...params }
  delete defaultParams.name
  delete defaultParams.message

  const SubErr = function( oMsg, oStatus, oFields ) {
    if ( !( this instanceof SubErr ) ) {
      return new SubErr( oMsg, oStatus, oFields )
    }
    if ( typeof oStatus === 'object' ) {
      oFields = oStatus
      oStatus = undefined
    }
    const oParams = { ...defaultParams, ...getParams( oMsg, oMsg, oStatus, undefined, oFields ) }
    Object.keys( oParams ).forEach( ( k ) => { this[k] = oParams[k] } )
    if ( Error.captureStackTrace ) {
      Error.captureStackTrace( this, this.constructor );
    }
    return undefined
  }

  SubErr.extend = this.extend
  SubErr.defaultParams = defaultParams

  return create( SubErr, parent, params )
}

const BaseErr = create( () => {}, Error )
BaseErr.extend = extend
BaseErr.prototype.toString = toString
BaseErr.prototype.toObject = toObject

module.exports = BaseErr.extend( )
